export default __webpack_public_path__ + "static/illustration-download.url-f227079d8392f7031fab15ea3d0c72f6.svg";